import { Link, useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import { AccountOfficer } from "../../models/interfaces";
import accountOfficerService from "../../services/accountOfficerService";
import { useEffect, useState } from "react";
import FormModal from "../../components/controls/FormModal/FormModal";
import Frame from "../../components/controls/Frame/Frame";
import FormCommand from "../../components/controls/FormCommand";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
import { MenuItem } from "../../models/menu";
import { MdCancel, MdDelete, MdEdit } from "react-icons/md";

export interface AccountOfficersProps {
  isModal?: boolean;
}

export function getAccountOfficerContextMenu(): MenuItem<AccountOfficer>[] {
  return [
    {
      onClick: (officer) => {
        alert(officer.name);
      },
      name: "Edit",
      icon: <MdEdit />,
    },
    {
      name: "Delete",
      onClick: (officer) => {
        alert("Delete " + officer.name);
      },
      icon: <MdDelete />,
    },
    {
      name: "Disable / Enable",
      onClick: (officer) => {
        alert("Disabled or enabled" + officer.name);
      },
      icon: <MdCancel />,
    },
  ];
}

export const AccountOfficers = (props: AccountOfficersProps) => {
  const navigate = useNavigate();

  const [accountOfficers, setOfficers] = useState<AccountOfficer[]>([]);
  const [officer, setOfficer] = useState<AccountOfficer>();

  const getOfficers = async (name: string) => {
    const res = await accountOfficerService.getOfficers({
      pageIndex: 1,
      recordCount: 40,
      name: name,
    });

    if (res.status) {
      setOfficers(res.data ?? []);
    }
  };

  const saveOfficer = async () => {
    const res = await accountOfficerService.addOrUpdateOfficer(
      {
        name: officer?.name ?? "",
      },
      officer?.id ?? 0
    );

    if (res.status) {
      alert(res.message);
      if (!officer?.id) {
        setOfficers([...accountOfficers, res.data as AccountOfficer]);
      }
    }
  };

  useEffect(() => {
    getOfficers("");
  });

  return (
    <div className="row">
      <div className="col">
        <Frame>
          <h4>Account Officers</h4>
          <GridView
            keys={["name"]}
            name={"lstAccountOfficers"}
            rowsPerPage={50}
            showSearchBar={true}
            showAddButton={true}
            onAddRecord={() => setOfficer({})}
          >
            <GridView.Header>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone No</th>
                  <th>Email</th>
                  <th>Action(s)</th>
                </tr>
              </thead>
            </GridView.Header>

            <GridView.Content>
              {accountOfficers.map((d) => (
                <tr>
                  <td>{d.name}</td>
                  <td>{d.email}</td>
                  <td>{d.phone}</td>
                  <td>
                    <ContextMenu
                      item={d}
                      menu={getAccountOfficerContextMenu()}
                    />
                  </td>
                </tr>
              ))}
            </GridView.Content>
          </GridView>

          {officer && (
            <FormModal onClose={() => setOfficer(undefined)}>
              <AccountOfficerForm></AccountOfficerForm>
            </FormModal>
          )}
        </Frame>
      </div>
    </div>
  );
};

export interface AccountOfficerFormProps {}

export function AccountOfficerForm(props: AccountOfficerFormProps) {
  return (
    <div className="row">
      <div className="col-12">
        <div className="form-group">
          <label htmlFor="officerName" className="control-label">
            Officer Name
          </label>
          <input
            type="text"
            name="officeName"
            id="officeName"
            className="form-control form-control-sm"
            placeholder="Enter the name of the officer"
          />
        </div>
        <FormCommand />
      </div>
    </div>
  );
}
